import { ReactNode } from "react";

import {
  Route,
  Redirect,
} from "react-router-dom";

import { ROUTE } from "route";
import { isDailyAdult } from "utils";

interface IAdultRoute {
  path: string;
  children: ReactNode;
}

/** @description 這邊應該抽出邏輯 */
export const AdultRoute: React.FC<IAdultRoute> = ({ children, ...rest }: IAdultRoute) => {
  return (
    <Route
      exact
      {...rest}
      render={({ location }) =>
        isDailyAdult() ?
          children:
          <Redirect
            to={`${ROUTE.INTRO}/?location=${location.pathname}${location.search}`}
          />
      }
    />
  );
};